<h2 mat-dialog-title>
  {{ 'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.IMPERSONATE_USER' | translate }}
</h2>
<div class="searchbox">
  <mat-form-field floatLabel="never">
    <input matInput #searchTerm [placeholder]="'OMNISEARCH.SEARCH_BY_NAME_ADDRESS_OR_PHONE_NUMBER' | translate" />
  </mat-form-field>
</div>
<mat-dialog-content>
  <mat-nav-list>
    <a
      tabindex="0"
      *ngFor="let user of people$ | async"
      (click)="impersonateUser(user)"
      (keyup.enter)="impersonateUser(user)"
    >
      <div class="user-box">
        <div class="user-type" [title]="(user.type === 'S' ? 'COMMON.SALESPERSON_LABEL' : 'COMMON.USER') | translate">
          <mat-icon>
            {{ user.type === 'S' ? 'monetization_on' : 'store' }}
          </mat-icon>
        </div>
        <div class="user-info">
          <h4 matListItemTitle>{{ user.firstName }} {{ user.lastName }}</h4>
          <p matListItemLine>{{ user.email }}{{ user.email && user.phoneNumber ? ' - ' : '' }}{{ user.phoneNumber }}</p>
        </div>
      </div>
    </a>
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
